import Footer from '@app/layouts/partials/footer'
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './style.scss'

export default function EmailVerification () {
  const [title, setTitle] = useState('')
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const successParam = params.get('success')
    if (successParam && successParam.toLowerCase() === 'true') {
      setTitle('メールの確認に成功しました。')
    } else {
      setTitle('電子メールの検証に失敗しました。')
    }
  }, [location.search])

  return (
    <div className="wrapper email-verification-wrapper">
      <header>
        <nav className="navbar navbar-expand-lg fixed-top px-3">
          <Link className="navbar-brand" to="/">
            <img src="/assets/img/logo.png" alt="" />
          </Link>
        </nav>
      </header>
      <main className="container-fluid">
        <div className="main-content">
          <div className="text-center fs-24">{title}</div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
